module.exports = __webpack_public_path__ + "static/together_bg4_m@2x-05cf5465fd0cf458048333b608551b1e.jpg";